import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function ArrowNorthEast({ width = 11, height = 11, fill = '#B7B7B7' }: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.13333 13.3667C3.01111 13.2445 2.95 13.0889 2.95 12.9C2.95 12.7112 3.01111 12.5556 3.13333 12.4334L10.4 5.16671H6.66666C6.47777 5.16671 6.31955 5.10293 6.192 4.97537C6.064 4.84737 6 4.68893 6 4.50004C6 4.31115 6.064 4.15271 6.192 4.02471C6.31955 3.89715 6.47777 3.83337 6.66666 3.83337H12C12.1889 3.83337 12.3471 3.89715 12.4747 4.02471C12.6027 4.15271 12.6667 4.31115 12.6667 4.50004V9.83337C12.6667 10.0223 12.6027 10.1805 12.4747 10.308C12.3471 10.436 12.1889 10.5 12 10.5C11.8111 10.5 11.6529 10.436 11.5253 10.308C11.3973 10.1805 11.3333 10.0223 11.3333 9.83337V6.10004L4.06666 13.3667C3.94444 13.4889 3.78889 13.55 3.6 13.55C3.41111 13.55 3.25555 13.4889 3.13333 13.3667Z"
        fill={fill}
      />
    </Svg>
  );
}
